export var EventHook;
(function (EventHook) {
    const cache = {};
    function get(type) {
        return cache[type] || {};
    }
    EventHook.get = get;
    function register(type, hook) {
        cache[type] = hook;
    }
    EventHook.register = register;
    function unregister(type) {
        delete cache[type];
    }
    EventHook.unregister = unregister;
})(EventHook || (EventHook = {}));
//# sourceMappingURL=hook.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6-common/es/dom/event/hook.js
// module id = null
// module chunks = 